import { cn } from "../utils/cn";

type InputProps = {
  label: string;
  placeholder?: string;
  hideLabel?: boolean;
  ariaLabel?: string;
  state?: "default" | "hover" | "active" | "focus" | "disabled" | "error";
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  readOnly?: boolean;
};

export function Input({ label, placeholder, hideLabel = false, ariaLabel, state = "default", value, onChange, onFocus, disabled, readOnly }: InputProps) {
  const isDisabled = disabled || state === "disabled";
  const stateClasses =
    state === "hover"
      ? "bg-surface-muted"
      : state === "active"
        ? "bg-border/40"
        : state === "focus"
          ? "outline outline-2 outline-primary/40 outline-offset-2"
          : state === "error"
            ? "border-danger"
          : "";
  const labelClass = state === "error" ? "text-danger" : "text-muted";
  const labelText = ariaLabel ?? label;
  return (
    <label className={cn("grid gap-2 text-sm", labelClass)}>
      <span className={cn(hideLabel && "sr-only")}>{label}</span>
      <input
        className={cn(
          "h-10 rounded-md border border-border bg-surface px-3 text-text",
          stateClasses,
          isDisabled && "opacity-50 cursor-not-allowed",
          readOnly && "cursor-pointer"
        )}
        disabled={isDisabled}
        readOnly={readOnly}
        aria-label={hideLabel ? labelText : undefined}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
      />
    </label>
  );
}
